import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// components
import { LoadingScreen } from 'src/commons/components/loading-screen';
// context
import { StepQrProvider } from 'src/features/qr-payment/context/step-context';
import { FormProvider } from 'src/features/qr-payment/context/form-provider';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/features/qr-payment'));

// ----------------------------------------------------------------------

export const qrPaymentRoutes = [
  {
    path: '/qr-payment',
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        element: (
          <FormProvider>
            <StepQrProvider>
              <IndexPage />
            </StepQrProvider>
          </FormProvider>
        ),
        index: true,
      },
    ],
  },
];
